import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    SaveButton,
    Toolbar,
    TextField,
    Labeled,
    DateField,
    Button,
    TopToolbar,
} from 'react-admin';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Grid, Stack, Box } from '@mui/material';

const EditActions = () => (
    <TopToolbar>
        <Button label="Hallinta" component={Link} to="/hallinta?tab=3">
            <ArrowBackIcon />
        </Button>
    </TopToolbar>
);

const EditToolbar = () => (
    <Toolbar>
        <SaveButton />
    </Toolbar>
);

function tryPrettyJson(value: string | undefined): string {
    if (!value) return '';
    try {
        return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
        return value;
    }
}

const SecretsEdit = () => (
    <Edit
        redirect="show"
        mutationMode="pessimistic"
        queryOptions={{ refetchOnMount: 'always', staleTime: 0 }}
        actions={<EditActions />}
    >
        <SimpleForm toolbar={<EditToolbar />}>
            <Grid container width={{ xs: '100%' }} spacing={2}>
                <Grid size={{ xs: 12, md: 8 }}>
                    <Labeled label="resources.secrets.fields.name">
                        <TextField source="name" />
                    </Labeled>
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <TextInput source="description" fullWidth multiline />
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                    <TextInput
                        source="secretString"
                        fullWidth
                        multiline
                        minRows={6}
                        format={tryPrettyJson}
                    />
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Stack direction="row" spacing={4}>
                        <Box>
                            <Labeled label="resources.secrets.fields.createdDate">
                                <DateField
                                    source="createdDate"
                                    showTime
                                    locales="fi-FI"
                                />
                            </Labeled>
                        </Box>
                        <Box>
                            <Labeled label="resources.secrets.fields.lastChangedDate">
                                <DateField
                                    source="lastChangedDate"
                                    showTime
                                    locales="fi-FI"
                                />
                            </Labeled>
                        </Box>
                        <Box>
                            <Labeled label="resources.secrets.fields.versionId">
                                <TextField source="versionId" />
                            </Labeled>
                        </Box>
                    </Stack>
                </Grid>
            </Grid>
        </SimpleForm>
    </Edit>
);

export default SecretsEdit;
